import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["fileInput", "submitButton"];

    connect() {
        this.chunkSize = 90 * 1024 * 1024; // 90MB
    }

    async uploadFile(event) {
        event.preventDefault();

        const file = this.fileInputTarget.files[0];
        const totalChunks = Math.ceil(file.size / this.chunkSize);
        const uploadUrl = event.target.action; // Read the URL from the form's action attribute

        for (let index = 0; index < totalChunks; index++) {
            const start = index * this.chunkSize;
            const end = Math.min(file.size, start + this.chunkSize);

            const chunk = file.slice(start, end);

            const formData = new FormData();
            formData.append("chunk", chunk);
            formData.append("filename", file.name);
            formData.append("is_last_chunk", index === totalChunks - 1);

            await this.sendChunk(formData, uploadUrl);
        }
    }

    async sendChunk(formData, uploadUrl) {
        try {
            const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            const response = await fetch(uploadUrl, {
                method: "POST",
                headers: {
                    'X-CSRF-Token': csrfToken // Include the CSRF token in the request headers
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            // Handle JSON response
            const data = await response.json();
            if (data.redirect_url) {
                // Store the notice message in session storage
                if (data.notice) {
                    sessionStorage.setItem('notice', data.notice);
                }
                // Redirect the user to the specified URL
                window.location.href = data.redirect_url;
            }

        } catch (error) {
            console.error("Error in file upload:", error);
        }
    }




}
